import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./router";
import "./assets/scss/main.scss";
import Deactivation from "./components/deactivation";

function App() {
  return (
        <Router>
          <Deactivation />
          <AppRoutes />
        </Router>
  );
}

export default App;
